import * as types from '../mutation-types';

const state = {
  from: null,
  to: null
};

const getters = {
  from: () => state.from,
  to: () => state.to
};

const actions = {
  navigate: ({ commit }, route) => {
    commit(types.SET_NAVIGATION, route);
  }
};

const mutations = {
  [types.SET_NAVIGATION](_, { from, to }) {
    state.from = from;
    state.to = to;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/navigation.js